let vehiclesCache = null;

const index = function (forceRefresh) {
    if (!forceRefresh && vehiclesCache) {
        return Promise.resolve({ data: vehiclesCache });
    }

    return window.axios.get('/api/vehicles').then((res) => {
        vehiclesCache = res.data;
        return res;
    });
};

const invalidateCache = function () {
    vehiclesCache = null;
};

const get = function (id) {
    return window.axios.get(`/api/vehicles/${id}`);
};

const create = function (data) {
    return window.axios.post('/api/vehicles', data).then((res) => {
        invalidateCache();
        return res;
    });
};

const update = function (data) {
    return window.axios.put(`/api/vehicles/${data.id}`, data).then((res) => {
        invalidateCache();
        return res;
    });
};

const deleteVehicle = function (id) {
    return window.axios.delete(`/api/vehicles/${id}`).then((res) => {
        invalidateCache();
        return res;
    });
};

const save = function (data) {
    if (data.id) {
        return update(data);
    }
    return create(data);
};

export default {
    index,
    invalidateCache,
    get,
    create,
    update,
    delete: deleteVehicle,
    save,
};



// WEBPACK FOOTER //
// ./resources/assets/js/services/VehicleService.js